import { defineAll } from '@app/utils/defineAll'

import type { GetAnnouncementsSearchStatsQuery } from '@app/packages/api/v2/types/params'
import type { SavedAnnouncementsFilter } from '@app/packages/savedAnnouncementsSearchFilter/SavedAnnouncementsFilter'

import { createThunk } from '@app/store/thunk'

export const convertSavedAnnouncementsFilterToStatsQuery = (filter: SavedAnnouncementsFilter) => {
  return createThunk(() => {
    return defineAll<GetAnnouncementsSearchStatsQuery>({
      require_attention: undefined,
      start: filter.start,
      end: filter.end,
      min_kids: filter.min_kids,
      max_kids: filter.max_kids,
      youngest_age_months: filter.youngest_age_months,
      eldest_age_months: filter.eldest_age_months,
      regular: filter.regular,
      online: filter.online,
      created_by: filter.created_by,
      latitude: filter.address?.coords.lat,
      longitude: filter.address?.coords.lon,
      distance: filter.address ? filter.address.radius / 1000 : undefined,
    })
  })
}
